{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "Avec verein.Cloud®, nous offrons une valeur ajoutée et des sources de revenus pour les associations qui vont au-delà des revenus des cotisations. Une plateforme de dons crée un accès automatisé au financement de plans et de projets. Grâce à l'accès profilé aux membres du club, les clubs peuvent intégrer leurs sponsors de manière plus durable. Les membres et les associations bénéficient de fonctions de fidélité, de bons ou de remboursements en espèces et d'autres valeurs ajoutées et services.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "Un lien de réinitialisation du mot de passe a été envoyé. Vérifiez votre boîte de réception pour un e-mail de support@verein.cloud.",
  "New Version is Available.": "Une nouvelle version est disponible.",
  "Please Click to Update": "Veuillez cliquer pour mettre à jour",
  "Forgot Password": "Mot de passe oublié",
  "Back to login": "Retour à la connexion",
  "Submit": "Soumettre",
  "Welcome": "Bienvenue",
  "Login Successful": "Connexion réussie",
  "Your account has been deleted. Please contact support. Logging out...": "Votre compte a été supprimé. Veuillez contacter le support. Déconnexion en cours...",
  "Your account has been deleted. Please contact support.": "Votre compte a été supprimé. Veuillez contacter le support.",
  "Admin": "Administrateur",
  "Member": "Membre",
  "Guest": "Invité",
  "Secretary": "Secrétaire",
  "Functionary": "Fonctionnaire",
  "Editor": "Éditeur",
  "User": "Utilisateur",
  "Member Light": "Membre Léger",
  "Member Light Admin": "Administrateur de Membre Léger",
  "About": "A propos",
  "Chairman": "Président",
  "Hello world !": "Bonjour le monde !",
  "Not Found": "Non trouvé",
  "Unauthorized Access": "Accès non autorisé",
  "Home": "Accueil",
  "Logged in as": "Connecté en tant que",
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Password": "Mot de passe",
  "Password is required": "Mot de passe requis",
  "Username": "Identifiant",
  "Username is required": "Identifiant requis",
  "Username or password incorrect.": "Identifiant ou mot de passe incorrect.",
  "Remember me": "Rester connecté",
  "Version": "Version",
  "Details": "Détails",
  "Yes": "Oui",
  "Old Password": "Ancien mot de passe",
  "New Password": "Nouveau mot de passe",
  "Confirm Password": "Confirmer le mot de passe",
  "Confirmation": "Confirmation",
  "Delete Confirmation": "Confirmation de Suppression",
  "Move to Trash Confirmation": "Déplacer vers la corbeille",
  "Leave Confirmation": "Confirmation de Départ",
  "Join Confirmation": "Confirmation de Rejoindre",
  "Approve Join Confirmation": "Confirmation d'Approbation de Rejoindre",
  "Accept Confirmation": "Confirmation d'acceptation",
  "Deny Confirmation": "Confirmation de refus",
  "Approve Confirmation": "Confirmation d'approbation",
  "Reject Confirmation": "Confirmation de rejet",
  "Shifts Delete Confirmation": "Confirmation de suppression des quarts",
  "Accept Successful": "Acceptation réussie",
  "Deny Successful": "Refus réussi",
  "Unapprove Successful": "Désapprobation réussie",
  "Approve Successful": "Approbation réussie",
  "Created Successfully": "Créé avec succès",
  "Update Successful": "Mise à jour réussie",
  "Delete Successful": "Suppression réussie",
  "Leave Successful": "Sortie réussie",
  "Join Successful": "Adhésion réussie",
  "Approved Successfully": "Approuvé avec succès",
  "Rejected Successfully": "Rejeté avec succès",
  "Message starred successfully": "Message étoilé avec succès",
  "Message moved to inbox successfully": "Message déplacé dans la boîte de réception avec succès",
  "Message saved as draft successfully": "Message enregistré en tant que brouillon avec succès",
  "Message moved to trash successfully": "Message déplacé dans la corbeille avec succès",
  "Error": "Erreur",
  "Something went wrong": "Quelque chose s'est mal passé !",
  "Are you sure you want to continue": "Êtes-vous sûr de vouloir continuer",
  "Are you sure you want to delete": "Êtes-vous sûr de vouloir supprimer",
  "Are you sure you want to leave": "Êtes-vous sûr de vouloir quitter",
  "Are you sure you want to join": "Êtes-vous sûr de vouloir rejoindre",
  "Are you sure you want to join {eventName} event on {eventDate}?": "Êtes-vous sûr de vouloir rejoindre l'événement <b>'{{eventName}}'</b> le <b>{{eventDate}}</b>?",
  "Are you sure you want to join {eventName} for all upcoming events?": "Êtes-vous sûr de vouloir rejoindre <b>'{{eventName}}'</b> pour tous les événements à venir?",
  "Are you sure you want to join {eventName} event on selected dates?": "Êtes-vous sûr de vouloir rejoindre l'événement <b>'{{eventName}}'</b> aux dates sélectionnées?",
  "Your current Request is waiting for the Approval": "Votre demande actuelle est en attente d'approbation.",
  "Current Request is waiting for the Approval by Admin": "La demande actuelle est en attente d'approbation par l'administrateur.",
  "Current request has been denied": "La demande actuelle a été refusée",
  "Your current request is Rejected": "Votre demande actuelle est rejetée",
  "Your current request is Approved": "Votre demande actuelle est approuvée",
  "Deny Reason": "Raison du refus",
  "Your current Request is waiting for the Approval by Admin": "Votre demande actuelle est en attente d'approbation par l'administrateur.",
  "Your current request is Denied by Admin": "Votre demande actuelle a été refusée par l'administrateur.",
  "Your update request is waiting for the approval by Admin": "Votre demande de mise à jour est en attente d'approbation par l'administrateur.",
  "Update request is waiting for the approval": "La demande de mise à jour est en attente d'approbation",
  "You have unsaved changes. Are you sure you want to leave": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "Êtes-vous sûr de vouloir accepter ceci ",
  "Are you sure you want to deny this": "Êtes-vous sûr de vouloir refuser cela ",
  "Are you sure you want to approve this": "Êtes-vous sûr de vouloir approuver ceci ",
  "Are you sure you want to reject this": "Êtes-vous sûr de vouloir rejeter ceci ",
  "Are you sure you want to unapprove this": "Êtes-vous sûr de vouloir désapprouver cela ",
  "Are you sure you want to accept this Course": "Êtes-vous sûr de vouloir accepter ce cours",
  "Are you sure you want to deny this Course": "Êtes-vous sûr de vouloir refuser ce cours",
  "Are you sure you want to approve this Course": "Êtes-vous sûr de vouloir approuver ce cours",
  "Are you sure you want to reject this Course": "Êtes-vous sûr de vouloir rejeter ce cours",
  "Are you sure you want to unapprove this Course": "Êtes-vous sûr de vouloir ne pas approuver ce cours",
  "Are you sure you want to accept this Event": "Êtes-vous sûr de vouloir accepter cet événement",
  "Are you sure you want to deny this Event": "Êtes-vous sûr de vouloir refuser cet événement",
  "Are you sure you want to approve this Event": "Êtes-vous sûr de vouloir approuver cet événement",
  "Are you sure you want to reject this Event": "Êtes-vous sûr de vouloir rejeter cet événement",
  "Are you sure you want to unapprove this Event": "Êtes-vous sûr de vouloir ne pas approuver cet événement",
  "Are you sure you want to accept this News": "Êtes-vous sûr de vouloir accepter cette actualité",
  "Are you sure you want to deny this News": "Êtes-vous sûr de vouloir refuser cette actualité",
  "Are you sure you want to approve this News": "Êtes-vous sûr de vouloir approuver cette actualité",
  "Are you sure you want to reject this News": "Êtes-vous sûr de vouloir rejeter cette actualité",
  "Are you sure you want to unapprove this News": "Êtes-vous sûr de vouloir ne pas approuver cette actualité",
  "Are you sure you want to accept this Task": "Êtes-vous sûr de vouloir accepter cette tâche",
  "Are you sure you want to deny this Task": "Êtes-vous sûr de vouloir refuser cette tâche",
  "Are you sure you want to approve this Task": "Êtes-vous sûr de vouloir approuver cette tâche",
  "Are you sure you want to reject this Task": "Êtes-vous sûr de vouloir rejeter cette tâche",
  "Are you sure you want to unapprove this Task": "Êtes-vous sûr de vouloir ne pas approuver cette tâche",
  "Are you sure you want to accept this Group": "Êtes-vous sûr de vouloir accepter ce groupe",
  "Are you sure you want to deny this Group": "Êtes-vous sûr de vouloir refuser ce groupe",
  "Are you sure you want to approve this Group": "Êtes-vous sûr de vouloir approuver ce groupe",
  "Are you sure you want to reject this Group": "Êtes-vous sûr de vouloir rejeter ce groupe",
  "Are you sure you want to unapprove this Group": "Êtes-vous sûr de vouloir ne pas approuver ce groupe",
  "Are you sure you want to accept this FAQ": "Êtes-vous sûr de vouloir accepter cette FAQ",
  "Are you sure you want to deny this FAQ": "Êtes-vous sûr de vouloir refuser cette FAQ",
  "Are you sure you want to approve this FAQ": "Êtes-vous sûr de vouloir approuver cette FAQ",
  "Are you sure you want to reject this FAQ": "Êtes-vous sûr de vouloir rejeter cette FAQ",
  "Are you sure you want to unapprove this FAQ": "Êtes-vous sûr de vouloir ne pas approuver cette FAQ",
  "Are you sure you want to accept this Instructor": "Êtes-vous sûr de vouloir accepter ce formateur",
  "Are you sure you want to deny this Instructor": "Êtes-vous sûr de vouloir refuser ce formateur",
  "Are you sure you want to approve this Instructor": "Êtes-vous sûr de vouloir approuver ce formateur",
  "Are you sure you want to reject this Instructor": "Êtes-vous sûr de vouloir rejeter ce formateur",
  "Are you sure you want to unapprove this Instructor": "Êtes-vous sûr de vouloir ne pas approuver ce formateur",
  "Are you sure you want to accept this Room": "Êtes-vous sûr de vouloir accepter cette salle",
  "Are you sure you want to deny this Room": "Êtes-vous sûr de vouloir refuser cette salle",
  "Are you sure you want to approve this Room": "Êtes-vous sûr de vouloir approuver cette salle",
  "Are you sure you want to reject this Room": "Êtes-vous sûr de vouloir rejeter cette salle",
  "Are you sure you want to unapprove this Room": "Êtes-vous sûr de vouloir ne pas approuver cette salle",
  "Are you sure you want to accept this Survey": "Êtes-vous sûr de vouloir accepter cette enquête",
  "Are you sure you want to deny this Survey": "Êtes-vous sûr de vouloir refuser cette enquête",
  "Are you sure you want to approve this Survey": "Êtes-vous sûr de vouloir approuver cette enquête",
  "Are you sure you want to reject this Survey": "Êtes-vous sûr de vouloir rejeter cette enquête",
  "Are you sure you want to unapprove this Survey": "Êtes-vous sûr de vouloir ne pas approuver cette enquête",
  "Are you sure you want to delete all shifts for": "Êtes-vous sûr de vouloir supprimer tous les quarts pour",
  "Are you sure you want to move this to trash": "Êtes-vous sûr de vouloir déplacer ceci vers la corbeille",
  "Are you sure you want to permanently delete this": "Êtes-vous sûr de vouloir supprimer définitivement ceci",
  "Are you sure you want to approve this join request": "Êtes-vous sûr de vouloir approuver cette demande de rejoindre",
  "Are you sure you want to delete this image": "Êtes-vous sûr de vouloir supprimer cette image",
  "Are you sure you want to delete this document": "Êtes-vous sûr de vouloir supprimer ce document",
  "Are you sure you want to complete this task": "Êtes-vous sûr de vouloir compléter cette tâche",
  "Club Surveys": "Enquêtes de club",
  "Active Polls": "Sondages actifs",
  "My Polls": "Mes sondages",
  "Completed Polls": "Sondages terminés",
  "Completed Surveys": "Enquêtes terminées",
  "Opinion Poll": "Sondage d'opinion",
  "owner": "Propriétaire",
  "Active on": "Actif sur",
  "Active from": "Actif à partir de",
  "Expired on": "Expire sur",
  "remaining time": "Temps restant",
  "status": "Statut",
  "Add Survey": "Ajouter un sondage",
  "View Survey": "Voir Sondage",
  "Delete Survey": "supprimer sondage",
  "Active Survey": "Sondage actif",
  "Close Survey": "Fermer le sondage",
  "Survey Activated Successfully": "Sondage activé avec succès",
  "Survey Closed Successfully": "Sondage fermé avec succès",
  "Survey Close Confirmation": "Confirmation de clôture du sondage",
  "Survey Active Confirmation": "Confirmation d'activation du sondage",
  "Are you sure you want to active": "Êtes-vous sûr de vouloir activer",
  "Are you sure you want to close": "Êtes-vous sûr de vouloir fermer",
  "Leave": "Quitter",
  "Edit": "Modifier",
  "Delete": "Supprimer",
  "Remove": "Supprimer",
  "Add": "Ajouter",
  "Create": "Créer",
  "Save": "Enregistrer",
  "Update": "Mettre à jour",
  "update": "Mettre à jour",
  "Cancel": "Annuler",
  "Back": "Retour",
  "accept": "Accepter",
  "Accept": "Accepter",
  "Decline": "Décliner",
  "deny": "Refuser",
  "Deny": "Refuser",
  "view": "Voir",
  "View": "Voir",
  "view survey": "Voir le Sondage",
  "view task": "Voir la Tâche",
  "View Task": "Voir la Tâche",
  "Drag and drop image here, or click to add image": "Glissez-déposez une image ici ou cliquez pour ajouter une image",
  "Drag and drop image here, or click to change image": "Glissez-déposez une image ici ou cliquez pour changer l'image",
  "Drag and drop file here, or click to add file": "Glissez-déposez un fichier ici ou cliquez pour ajouter un fichier",
  "Drag and drop file here, or click to change file": "Glissez-déposez un fichier ici ou cliquez pour changer le fichier",
  "Add Image": "Ajouter une image",
  "Add File": "Ajouter un fichier",
  "Change Image": "Changer l'image",
  "View more": "Voir plus",
  "Notifications": "Notifications",
  "See more Notifications": "Voir plus de notifications",
  "Title": "Titre",
  "Start Date": "Date de début",
  "End Date": "Date de fin",
  "New Survey": "Nouveau sondage",
  "Survey Edit": "Modifier le sondage",
  "Survey Details": "Détails du sondage",
  "Survey": "Sondage",
  "Question": "Question",
  "Single selection": "Sélection unique",
  "Multiple selection": "Sélection multiple",
  "Add Choice": "Ajouter un choix",
  "Enter your question": "Entrez votre question",
  "Publish": "Publier",
  "Add Question": "Ajouter une question",
  "Enter your survey name": "Entrez le nom de votre sondage",
  "Assigned tasks": "Tâches assignées",
  "About event": "À propos de l'événement",
  "Event details": "Détails de l'événement",
  "Clear All": "Tout effacer",
  "Select Date": "Sélectionner une date",
  "Delete Banner": "Supprimer la bannière",
  "Banner": "Bannière",
  "Banners": "Bannières",
  "Email Type": "Type d'e-mail",
  "Subject": "Objet",
  "To": "À",
  "Cc": "Cc",
  "Recipients": "Destinataires",
  "Edit Draft Message": "Modifier le Brouillon",
  "Header Content": "Contenu de l'en-tête",
  "Template Body": "Corps du modèle",
  "Footer Content": "Contenu du pied de page",
  "Url": "URL",
  "Action": "Action",
  "Thumbnail": "Vignette",
  "From": "De",
  "Template Type": "Type de modèle",
  "Header Subject": "Objet de l'en-tête",
  "Email Template": "Modèle d'e-mail",
  "Create Email Template": "Créer un modèle d'e-mail",
  "Content": "Contenu",
  "instructor": "Instructeur",
  "survey": "Sondage",
  "course": "Cours",
  "updatedcourse": "Cours Mis à Jour",
  "Select Option": "Sélectionner une option",
  "Select Options": "Sélectionner des options",
  "Tag": "Tag",
  "Tags": "Tags",
  "Tag Name": "Nom du tag",
  "Create Tag": "Créer un tag",
  "Instructor Tag Name": "Nom du tag de l'instructeur",
  "Room Tag Name": "Nom du tag de la salle",
  "Courses": "Cours",
  "Instructor": "Instructeur",
  "Room": "Salle",
  "Rooms": "Salles",
  "New Tag": "Nouveau tag",
  "Task": "Tâche",
  "task": "Tâche",
  "Event": "Événement",
  "Events": "Événements",
  "Event Name": "Nom de l'événement",
  "Event Type": "Type d'événement",
  "FAQs": "FAQ",
  "Surveys": "Sondages",
  "News": "Actualités",
  "news": "Actualités",
  "news posts": "Articles d'Actualités",
  "news post": "Article d'Actualité",
  "create news post": "Créer un Article d'Actualité",
  "edit news post": "Modifier un Article d'Actualité",
  "news post details": "Détails de l'Article d'Actualité",
  "discover": "Découvrir",
  "create news": "Créer une actualité",
  "news from the groups": "Actualités des groupes",
  "No Available Content": "Aucun contenu disponible",
  "re you sure you want to delete this Tag?": "Êtes-vous sûr de vouloir supprimer ce tag ?",
  "Update Tag": "Mettre à jour le tag",
  "Add task": "Ajouter une tâche",
  "Tasks": "Tâches",
  "Task details": "Détails de la tâche",
  "Create task": "Créer une tâche",
  "Edit task": "Modifier une tâche",
  "All tasks": "Toutes les tâches",
  "My tasks": "Mes tâches",
  "Completed tasks": "Tâches terminées",
  "Open tasks": "Tâches ouvertes",
  "Group tasks": "Tâches de groupe",
  "New task": "Nouvelle tâche",
  "Subtasks": "Sous-tâches",
  "Add Sub-task": "Ajouter une sous-tâche",
  "Select date": "Sélectionner une date",
  "Select Time": "Sélectionner l'heure",
  "ToDo": "À faire",
  "In-Progress": "En cours",
  "InProgress": "En cours",
  "Completed": "Terminé",
  "Comments": "Commentaires",
  "Assigned": "Assigné",
  "Assign to": "Assigner à",
  "Add a Card": "Ajouter une carte",
  "Add Card": "Ajouter une carte",
  "Add element": "Ajouter un élément",
  "Enter a title for this card": "Entrez un titre pour cette carte",
  "Tasks to be completed": "Tâches à compléter",
  "No Available Tasks": "Aucune tâche disponible",
  "Group": "Groupe",
  "Individual": "Individuel",
  "Task type": "Type de tâche",
  "Add Tag": "Ajouter un tag",
  "Enter Title": "Entrez le titre",
  "Enter Description": "Entrez la description",
  "Select": "Sélectionner",
  "News Posts": "Articles d'actualités",
  "Posts": "Articles",
  "Message Chats": "Discussions de messages",
  "Message": "Message",
  "Chats": "Discussions",
  "Tasks Events": "Événements des tâches",
  "news from the club": "nouvelles du club",
  "News from the group": "Nouvelles du groupe",
  "News from the Company": "Nouvelles de l'entreprise",
  "Current club dates": "Dates actuelles du club",
  "Current company dates": "Dates actuelles de l'entreprise",
  "Participant": "Participant",
  "Read more": "Lire la suite",
  "Clock": "Horloge",
  "Popular": "Populaire",
  "Latest": "Dernier",
  "Available Tasks": "Tâches disponibles",
  "Available": "Disponible",
  "New": "Nouveau",
  "No News": "Aucune nouvelle",
  "Menu": "Menu",
  "Answer Options": "Options de réponse",
  "Enter answer choice": "Entrez le choix de réponse",
  "Answer": "Réponse",
  "Survey Type": "Type de sondage",
  "Type": "Type",
  "View Options": "Voir les options",
  "Notification": "Notification",
  "Anonymous Voting": "Vote anonyme",
  "Allow Correcting the Cast Vote": "Autoriser la correction du vote",
  "Multiple Choice": "Choix multiples",
  "Single Choice": "Choix unique",
  "Web Notification": "Notification Web",
  "Email Notification": "Notification par e-mail",
  "Always": "Toujours",
  "After Voting": "Après le vote",
  "Never": "Jamais",
  "All Club": "Tout le club",
  "All Important Dates": "Toutes les Dates Importantes",
  "Jubilees": "Jubilés",
  "Birthdays": "Anniversaires",
  "Anniversary": "Anniversaire",
  "Birthday": "Anniversaire",
  "days ago": "jours avant",
  "days left": "jours restants",
  "years": "années",
  "years in club": "années dans le club",
  "Today": "Aujourd'hui",
  "Today is": "Aujourd'hui c'est",
  "No upcoming birthdays or anniversaries": "Pas de prochains anniversaires ou anniversaires à venir",
  "Say Congrats": "Dire Félicitations",
  "Reply": "Répondre",
  "Reply All": "Répondre à tous",
  "Forward": "Transférer",
  "No Messages": "Pas de messages",
  "All Events": "Tous les Événements",
  "Club Event": "Événement du Club",
  "Group Event": "Événements de Groupe",
  "Functionaries Event": "Événement des Fonctionnaires",
  "Course": "Cours",
  "Seminar": "Séminaire",
  "Items Per Page": "Éléments par page",
  "Description": "Description",
  "Enter to search": "Appuyez sur Entrée pour rechercher",
  "New Chat": "Nouveau Chat",
  "New Email": "Nouvel e-mail",
  "Email": "E-mail",
  "E-Mail": "E-Mail",
  "Select an email to start communication": "Sélectionnez un e-mail pour commencer la communication",
  "Select a chat to start messaging": "Sélectionnez une discussion pour commencer à envoyer des messages",
  "Looks like you haven’t initiated a conversation with any of your team members": "On dirait que vous n'avez pas initié de conversation avec l'un de vos membres de l'équipe",
  "Enter your survey description": "Entrez la description de votre sondage",
  "Manage members and set their access level in your workspace": "Gérez les membres et définissez leur niveau d'accès dans votre espace de travail",
  "New Message": "Nouveau message",
  "Message Type": "Type de message",
  "Add a subject...": "Ajouter un sujet...",
  "Select A Message": "Sélectionner un message",
  "Choose File": "Choisir un fichier",
  "Change File": "Changer de fichier",
  "Type a message...": "Tapez un message...",
  "Draft": "Brouillon",
  "Drafts": "Brouillons",
  "Send": "Envoyer",
  "Bin": "Corbeille",
  "All Messages": "Tous les messages",
  "Posted": "Posté",
  "Marked": "Marqué",
  "Inbox": "Boîte de réception",
  "Trash": "Corbeille",
  "Starred": "Étoilé",
  "Sent": "Envoyé",
  "All Mails": "Tous les Mails",
  "Personal": "Personnel",
  "Sorting": "Tri",
  "Active Member": "Membre actif",
  "Membership number": "Numéro d'adhésion",
  "In the team since": "Dans l'équipe depuis",
  "In the club since": "Dans le club depuis",
  "Category": "Catégorie",
  "Position": "Position",
  "Category Name": "Nom de la catégorie",
  "Select Language": "Sélectionner la langue",
  "Select Theme": "Sélectionner le thème",
  "No record found": "Aucun enregistrement trouvé",
  "No items available": "Aucun élément disponible",
  "No tags available": "Aucun tag disponible",
  "Internal": "Interne",
  "External": "Externe",
  "Booked Out": "Réservé",
  "Internal Instructor": "Instructeur interne",
  "External Instructor": "Instructeur externe",
  "Instructor Type": "Type d'instructeur",
  "Faq Category": "Catégorie de FAQ",
  "Faq Category Name": "Nom de la catégorie de FAQ",
  "Sort and Filter": "Trier et filtrer",
  "Clear": "Effacer",
  "Select Tags": "Sélectionner des tags",
  "Name of the Event": "Nom de l'événement",
  "Venue": "Lieu",
  "Add Venue": "Ajouter un lieu",
  "No venue available": "Aucun lieu disponible",
  "Event Venues": "Lieux d'événements",
  "Create Event Venue": "Créer un lieu d'événement",
  "Event Venue Name": "Nom du lieu de l'événement",
  "Event Types": "Types d'événements",
  "Visibility of Event": "Visibilité de l'événement",
  "Show Guests": "Afficher les invités",
  "Chargeable": "Payant",
  "Additional Features": "Fonctionnalités supplémentaires",
  "Event Price": "Prix de l'événement",
  "Assign a task to an event": "Assigner une tâche à un événement",
  "Task Description": "Description de la tâche",
  "Task Types": "Types de tâches",
  "Week Days": "Jours de la semaine",
  "Recurrence": "Récurrence",
  "Start Time": "Heure de début",
  "End Time": "Heure de fin",
  "Event Date": "Date de l'événement",
  "Event Time": "Heure de l'événement",
  "Room No (optional)": "Numéro de salle (optionnel)",
  "Repeat Event": "Répéter l'événement",
  "Image": "Image",
  "Enter Price": "Entrez le prix",
  "Time From": "Heure de",
  "Time To": "Heure à",
  "Every": "Chaque",
  "Days": "Jours",
  "Weeks": "Semaines",
  "Months": "Mois",
  "Years": "Années",
  "Day": "Jour",
  "Repeat Daily": "Répéter quotidiennement",
  "Repeat Weekly": "Répéter chaque semaine",
  "Repeat Monthly": "Répéter chaque mois",
  "Repeat Yearly": "Répéter chaque année",
  "Public": "Public",
  "Private": "Privé",
  "Club": "Club",
  "Clubs": "Clubs",
  "Company": "Entreprise",
  "Does Not Repeat": "Ne se répète pas",
  "Every Day": "Chaque jour",
  "Every Week": "Chaque semaine",
  "Every Month": "Chaque mois",
  "Every Year": "Chaque année",
  "Custom": "Personnalisé",
  "Club  Event": "Événement du Club",
  "Participants": "Participants",
  "Select Participants": "Sélectionner les participants",
  "Private Group": "Groupe privé",
  "Course Information": "Informations sur le cours",
  "Place": "Lieu",
  "Date": "Date",
  "Time": "Heure",
  "Instructor Name": "Nom de l'instructeur",
  "Available Times": "Heures disponibles",
  "Qualification": "Qualification",
  "More Courses": "Plus de cours",
  "Theme": "Thème",
  "Room Information": "Informations sur la salle",
  "Task Details": "Détails de la tâche",
  "Assignment": "Affectation",
  "Due Date": "Date d'échéance",
  "Room Details": "Détails de la salle",
  "Address": "Adresse",
  "People": "Personnes",
  "Pending": "En attente",
  "Approved": "Approuvé",
  "Room Info": "Info salle",
  "To be submitted at the of course": "À soumettre à la fin du cours",
  "Add Course": "Ajouter un cours",
  "Add Location": "Ajouter un lieu",
  "Add Tags": "Ajouter des tags",
  "Course Date": "Date du cours",
  "Allowed Persons": "Personnes autorisées",
  "Add a Title": "Ajouter un titre",
  "Headline": "Titre",
  "Types": "Types",
  "Enter headline": "Entrez le titre",
  "Enter content": "Entrez le contenu",
  "News Highlight": "Actualités en vedette",
  "Club News": "Actualités du club",
  "Company News": "Actualités de l'entreprise",
  "New from the club": "Nouveau du club",
  "New Posts": "Nouveaux articles",
  "Task Events": "Événements des tâches",
  "Groups": "Groupes",
  "Group Details": "Détails du groupe",
  "Delete Group": "Supprimer le groupe",
  "Leave Group": "Quitter le groupe",
  "Join Group": "Rejoindre le groupe",
  "Join": "Rejoindre",
  "Group Name": "Nom du groupe",
  "Course Name": "Nom du Cours",
  "Visibility": "Visibilité",
  "No file chosen": "Aucun fichier sélectionné",
  "Assign a task to course": "Attribuer une tâche au cours",
  "Please fill all required fields": "Veuillez remplir tous les champs obligatoires",
  "Room Availability": "Disponibilité de la Salle",
  "Room Capacity": "Capacité de la Salle",
  "Room Charges": "Frais de la Salle",
  "Room Current Bookings": "Réservations Actuelles de la Salle",
  "Instructor Availability": "Disponibilité de l'Instructeur",
  "Instructor Current Bookings": "Réservations Actuelles de l'Instructeur",
  "Instructor not available for the following dates and times": "Instructeur non disponible pour les dates et heures suivantes",
  "Room not available for the following dates and times": "Salle non disponible pour les dates et heures suivantes",
  "Not within availability": "Pas dans la disponibilité",
  "Add News": "Ajouter des actualités",
  "Waiting for Approval": "En attente d'approbation",
  "Are you sure you want to complete this": "Êtes-vous sûr de vouloir terminer ceci",
  "Please complete all subtasks before marking the task as completed": "Veuillez terminer toutes les sous-tâches avant de marquer la tâche comme terminée",
  "Mark subtask as complete to move task to In Progress": "Marquez la sous-tâche comme terminée pour déplacer la tâche en cours",
  "wants to join a Group": "veut rejoindre un groupe appelé",
  "wants to publish an updated Group": "veut publier une mise à jour d'un groupe appelé",
  "has updated the Group": "a mis à jour le groupe",
  "invited you to": "vous a invité à",
  "wants to publish a Group": "veut publier un groupe appelé",
  "has denied the Group": "a refusé le groupe",
  "has been added to the Group": "a été ajouté au groupe",
  "has published the Group": "a publié le groupe",
  "wants to publish a News": "veut publier un article appelé",
  "wants to publish an updated News": "veut publier une mise à jour d'un article appelé",
  "has denied the News": "a refusé l'article",
  "has published the News": "a publié les actualités",
  "has updated the News": "a mis à jour les actualités",
  "wants to publish an Event": "veut publier un événement appelé",
  "wants to publish an updated Event": "veut publier une mise à jour d'un événement appelé",
  "has denied the Event": "a refusé l'événement",
  "has published the Event": "a publié l'événement",
  "has updated the Event": "a mis à jour l'événement",
  "invited you to an Event": "a été invité à un événement",
  "has updated Event for existing users": "a été mis à jour pour les utilisateurs existants",
  "wants to publish a Course": "veut publier un cours appelé",
  "wants to publish an updated Course": "veut publier une mise à jour d'un cours appelé",
  "wants to join a Course you have created": "veut rejoindre un cours que vous avez créé",
  "has been added to a Course by the creator": "a été ajouté à un cours par le créateur",
  "invited you to a Course": "a été invité à un cours",
  "wants to assign Instructor to a Course": "veut attribuer des instructeurs à un cours",
  "wants to update assigned Instructor of a Course": "veut mettre à jour les instructeurs attribués à un cours",
  "has published the Course": "a publié le cours",
  "has updated the Course": "a mis à jour le cours",
  "has denied the Course": "a refusé le cours",
  "invited you to a Task": "a été invité à une tâche",
  "wants to publish a Task": "veut publier une tâche appelée",
  "wants to publish an updated Task": "veut publier une mise à jour d'une tâche appelée",
  "has unapproved the Task": "a des tâches non approuvées",
  "has unapproved the Subtask": "a des sous-tâches non approuvées",
  "has denied the Task": "a refusé la tâche",
  "has published the Task": "a publié la tâche",
  "has updated the Task": "a mis à jour la tâche",
  "has completed the Task": "a terminé une tâche",
  "has sent you a message": "vous a envoyé un message",
  "wants to publish a Survey": "veut publier une enquête appelée",
  "wants to publish an updated Survey": "veut publier une mise à jour d'une enquête appelée",
  "has invited you to participate in a Survey": "vous a invité à participer à une enquête",
  "has published the Survey": "a publié l'enquête",
  "has updated the Survey": "a mis à jour l'enquête",
  "has denied the Survey": "a refusé l'enquête",
  "wants to publish a Room": "veut publier une salle",
  "wants to publish an updated Room": "veut publier une salle mise à jour",
  "has published the Room": "a publié la salle",
  "has updated the Room": "a mis à jour la salle",
  "has denied the Room": "a refusé la salle",
  "wants to publish an Instructor": "veut publier un instructeur",
  "wants to publish an updated Instructor": "veut publier un instructeur mis à jour",
  "has denied the Instructor": "a refusé l'instructeur",
  "has published the Instructor": "a publié l'instructeur",
  "has updated the Instructor": "a mis à jour l'instructeur",
  "wants to publish an FAQ": "veut publier un FAQ",
  "wants to publish an updated FAQ": "veut publier un FAQ mis à jour",
  "has published the FAQ": "a publié le FAQ",
  "wants to publish an updated FAQ to author": "veut publier un FAQ mis à jour à l'auteur",
  "has denied the FAQ to author": "a refusé le FAQ à l'auteur",
  "wants to publish an FAQ category": "veut publier une catégorie de FAQ",
  "Unknown notification type": "Type de notification inconnu",
  "Occupancy": "Occupation",
  "Free": "Libre",
  "Calendar": "Calendrier",
  "Jan": "Jan",
  "Feb": "Fév",
  "Mar": "Mar",
  "Apr": "Avr",
  "May": "Mai",
  "Jun": "Juin",
  "Jul": "Juil",
  "Aug": "Août",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Déc",
  "mo": "Lu",
  "tu": "Ma",
  "we": "Me",
  "th": "Je",
  "fr": "Ve",
  "sa": "Sa",
  "su": "Di",
  "mo 1": "L",
  "tu 1": "M",
  "we 1": "M",
  "th 1": "J",
  "fr 1": "V",
  "sa 1": "S",
  "su 1": "D",
  "current": "Actuel",
  "all": "Tout",
  "monday": "Lundi",
  "tuesday": "Mardi",
  "wednesday": "Mercredi",
  "thursday": "Jeudi",
  "friday": "Vendredi",
  "saturday": "Samedi",
  "sunday": "Dimanche",
  "january": "Janvier",
  "february": "Février",
  "march": "Mars",
  "april": "Avril",
  "may": "Mai",
  "june": "Juin",
  "july": "Juillet",
  "august": "Août",
  "september": "Septembre",
  "october": "Octobre",
  "november": "Novembre",
  "december": "Décembre",
  "just now": "à l'instant",
  "a minute ago": "il y a une minute",
  "minutes ago": "il y a quelques minutes",
  "an hour ago": "il y a une heure",
  "hours ago": "il y a quelques heures",
  "yesterday": "hier",
  "a week ago": "il y a une semaine",
  "weeks ago": "il y a quelques semaines",
  "Click to download": "Cliquez pour télécharger",
  "Click to preview": "Cliquez pour prévisualiser",
  "Survey Results": "Résultats du sondage",
  "Survey Results Details": "Détails des résultats du sondage",
  "Survey Created By": "Sondage créé par",
  "Survey Has been Closed": "Le sondage a été fermé",
  "You've not voted": "Vous n'avez pas voté",
  "My Vote": "Mon vote",
  "To Vote": "Pour voter",
  "My Vote: You can select Multiple Options": "Mon vote: Vous pouvez sélectionner plusieurs options",
  "My Vote: You can select only one option": "Mon vote: Vous ne pouvez sélectionner qu'une seule option",
  "Following people has voted For this option:": "Les personnes suivantes ont voté pour cette option:",
  "Total Number of Votes for this Option:": "Nombre total de votes pour cette option:",
  "other": "autre",
  "Members": "Membres",
  "Search Filter": "Filtre de recherche",
  "Search": "Rechercher",
  "Search Results": "Résultats de la recherche",
  "Last Active": "Dernière activité",
  "Status": "Statut",
  "Role": "Rôle",
  "Online": "En ligne",
  "Offline": "Hors ligne",
  "List": "Liste",
  "Members List": "Liste des membres",
  "Created": "Créé",
  "Paid": "Payé",
  "Unpaid": "Non payé",
  "Active": "Actif",
  "Inactive": "Inactif",
  "Apply Filter": "Appliquer le filtre",
  "Anonymous": "Anonyme",
  "Show hidden events": "Afficher les événements masqués",
  "Hide Event": "Masquer les événement",
  "UnHide Event": "Afficher l'événement",
  "Banner Placement": "Emplacement de la bannière",
  "Banner Display Tags": "Tags d'affichage de la bannière",
  "Create New Tag": "Créer un nouveau tag",
  "Task Type": "Type de tâche",
  "Leave Event": "Quitter l'événement",
  "Join Event": "Rejoindre l'événement",
  "Join This Event": "Rejoindre cet événement",
  "Join All Events in Series": "Rejoindre tous les événements de la série",
  "Join Event on Specific Dates": "Rejoindre l'événement à des dates spécifiques",
  "Accept event": "Accepter l'événement",
  "Deny event": "Refuser l'événement",
  "Publish event": "Publier l'événement",
  "Event Members": "Membres de l'événement",
  "Event Tasks": "Tâches de l'événement",
  "Event Details": "Détails de l'événement",
  "About group": "À propos du groupe",
  "Show more": "Afficher plus",
  "Your team": "Votre équipe",
  "Responsible": "Responsable",
  "Collaborators": "Collaborateurs",
  "Work Shifts": "Quarts de travail",
  "Create Work Shift": "Créer un quart de travail",
  "NO Of Shifts": "Nombre de quarts",
  "No Shifts Data found": "Aucune donnée de quarts trouvée",
  "Error while fetching Shifts Details": "Erreur lors de la récupération des détails des quarts",
  "Shift": "Équipe",
  "Form": "Formulaire",
  "No new notifications": "Pas de nouvelles notifications",
  "No Data": "Pas de données",
  "Add Work-shifts to an event": "Ajouter des quarts de travail à un événement",
  "Click to open details": "Cliquez pour ouvrir les détails",
  "permanently": "définitivement",
  "Folder": "Dossier",
  "Star Message": "Marquer le message",
  "Unstar Message": "Démarquer le message",
  "Impressum": "Mentions Légales",
  "Terms and Conditions": "Conditions Générales",
  "Terms of Use": "Conditions d'Utilisation",
  "Privacy Policy": "Politique de Confidentialité",
  "You can find our applicable documents here": "Vous pouvez trouver nos documents applicables ici",
  "Club Administration": "Administration du Club",
  "Financial Accounting": "Comptabilité Financière",
  "License & More": "Licence & Plus",
  "Documents": "Documents",
  "Current Statuses": "Statuts Actuels",
  "Corporate Philosophy": "Philosophie d'Entreprise",
  "Corporate": "Entreprise",
  "Archive": "Archivé",
  "All": "Tous",
  "Tables": "Tables",
  "Images": "Images",
  "Delete File": "Supprimer le Fichier",
  "Download File": "Télécharger le Fichier",
  "Preview Image": "Aperçu de l'image",
  "Upload Document": "Télécharger le Document",
  "Move to My Documents": "Déplacer vers Mes Documents",
  "Move to Archived": "Déplacer vers Archivé",
  "Move to Current Statuses": "Déplacer vers Statuts Actuels",
  "Move to Club Documents": "Déplacer vers Documents du Club",
  "Move to Corporate Documents": "Déplacer vers Documents d'Entreprise",
  "Move to Corporate Philosophy": "Déplacer vers Philosophie d'Entreprise",
  "Ascending": "Croissant",
  "Descending": "Décroissant",
  "Order By": "Trier par",
  "Order": "Ordre",
  "date": "Date",
  "name": "Nom",
  "Are you sure you want to move": "Êtes-vous sûr de vouloir déplacer",
  "Document moved successfully": "Document déplacé avec succès",
  "Only PDF files are allowed in Current Statuses": "Seules les fichiers PDF sont autorisés dans les Statuts Actuels",
  "Upload Successful": "Téléversement Réussi",
  "Profile": "Profil",
  "Attachment": "Pièce jointe",
  "Download Attachment": "Télécharger la pièce jointe",
  "Author": "Auteur",
  "CRM Surveys": "Enquêtes CRM",
  "CRM Survey": "Enquête CRM",
  "Voting Results": "Résultats du vote",
  "Total Votes": "Votes totaux",
  "Votes": "Votes",
  "Close": "Fermer",
  "Thank you for your vote": "Merci pour votre vote",
  "By": "Par",
  "CRM News": "Actualités CRM",
  "Read": "Lu",
  "Mark all notifications as read": "Marquer toutes les notifications comme lues",
  "Close this notification": "Fermer cette notification",
  "Phone": "Téléphone",
  "Published by": "Publié par",
  "Deleted User": "Utilisateur supprimé",
  "Delete Chat": "Supprimer la discussion",
  "Availability": "Disponibilité",
  "Availability locked due to bookings.": "Disponibilité bloquée pour réservations.",
  "Enter Name": "Entrez le nom",
  "Enter Email": "Entrez l'e-mail",
  "Phone No": "Numéro de téléphone",
  "Enter Phone No": "Entrez le numéro de téléphone",
  "Enter Address": "Entrez l'adresse",
  "No Of Persons": "Nombre de personnes",
  "Enter No Of Persons": "Entrez le nombre de personnes",
  "Price": "Prix",
  "First Name": "Prénom",
  "Enter First Name": "Entrez le prénom",
  "Last Name": "Nom de famille",
  "Enter Last Name": "Entrez le nom de famille",
  "Enter Qualification": "Entrez la qualification",
  "Repeat Course": "Répéter le cours",
  "Delete Selected": "Supprimer la sélection",
  "Deselect All": "Désélectionner tout",
  "Statistics": "Statistiques",
  "Clicks": "Clics",
  "Banner Statistics": "Statistiques de la bannière",
  "Banner Desktop Clicks": "Clics sur la bannière de bureau",
  "Select Admin": "Sélectionner l'administrateur",
  "Group Chat": "Discussion de groupe",
  "Groupchat": "Discussion de groupe",
  "Personal Chat": "Discussion personnelle",
  "Created By": "Créé par",
  "Invoice": "Facture",
  "Profile Image": "Image de profil",
  "Share Birthday": "Partager l'anniversaire",
  "Allow Advertisement": "Autoriser la publicité",
  "Date From": "Date de",
  "Date To": "Date à",
  "m ago": "il y a {{count}} minute(s)",
  "h ago": "il y a {{count}} heure(s)",
  "d ago": "il y a {{count}} jour(s)",
  "w ago": "il y a {{count}} semaine(s)",
  "mo ago": "il y a {{count}} mois",
  "Completed Subtasks": "Sous-tâches terminées",
  "Total Subtasks": "Total des sous-tâches",
  "Task Assigned to": "Tâche assignée à",
  "To be done by": "À faire par",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "Cette tâche ne peut être complétée que par l'administrateur, l'organisateur et les collaborateurs de cette tâche",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "Vous n'avez pas la permission de compléter cette sous-tâche, seuls les participants de cette tâche et des sous-tâches, l'organisateur de cette tâche et l'administrateur peuvent compléter cette sous-tâche",
  "Desktop": "Bureau",
  "Notification Section": "Section des notifications",
  "Everywhere": "Partout",
  "Welcome to your club community!": "Bienvenue dans votre communauté de club !",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Restez connecté avec votre club, échangez des idées et organisez tout en un seul endroit.",
  "Everything you need for your club - in one place.": "Tout ce dont vous avez besoin pour votre club - en un seul endroit.",
  "Simply register, contact members, plan appointments and achieve more together.": "Inscrivez-vous simplement, contactez les membres, planifiez des rendez-vous et réalisez plus ensemble.",
  "Stay connected - anytime, anywhere.": "Restez connecté - à tout moment, n'importe où.",
  "Access important information, share news and collaborate with your team.": "Accédez à des informations importantes, partagez des actualités et collaborez avec votre équipe.",
  "Happy Birthday": "Joyeux Anniversaire",
  "Happy Anniversary": "Joyeux Anniversaire",
  "Instant and uncomplicated chatting with members or groups": "Discuter instantanément et sans complication avec des membres ou des groupes",
  "Your own mailbox based on the classic e-mail": "Votre propre boîte aux lettres basée sur l'e-mail classique",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Type ou taille de fichier invalide. Seules les images PNG, JPEG et les documents autorisés de moins de 10 Mo sont autorisés",
  "Club Overview": "Aperçu du club",
  "Happenings": "Événements",
  "Occasions": "Occasions",
  "No:": "N°",
  "Password changed successfully. Please login again": "Mot de passe modifié avec succès. Veuillez vous reconnecter",
  "This is a private group. You need to request to join this group": "C'est un groupe privé. Vous devez demander à rejoindre ce groupe",
  "Your request to join this group is pending": "Votre demande pour rejoindre ce groupe est en attente",
  "Your request to join this group has been rejected": "Votre demande pour rejoindre ce groupe a été rejetée",
  "Confirm Delete": "Confirmer la suppression",
  "No news has been created in the club yet": "Aucune actualité n'a encore été créée dans le club",
  "No news has been created in any Group yet": "Aucune actualité n'a encore été créée dans aucun groupe",
  "No group has been created in the club yet": "Aucun groupe n'a encore été créé dans le club",
  "No events available": "Aucun événement disponible",
  "Additional address": "Adresse supplémentaire",
  "You have no notifications": "Vous n'avez pas de notifications",
  "Information about the course": "Informations sur le cours",
  "Further information about the course": "Informations supplémentaires sur le cours",
  "Invite Participants": "Inviter des participants",
  "Select all": "Sélectionner tout",
  "Unselect all": "Désélectionner tout",
  "Done": "Terminé",
  "You already have a pending change request": "Vous avez déjà une demande de changement en attente",
  "Messages": "Messages",
  "Calendar view": "Vue calendrier",
  "Card view": "Vue carte",
  "Mark As Complete": "Marquer comme terminé",
  "No Bookings": "Aucune réservation",
  "Schedule view": "Vue du calendrier",
  "Hide Empty Slots": "Masquer les créneaux vides",
  "Group Filter": "Filtre de groupe",
  "No Conversation": "Aucune conversation",
  "Select Event Dates": "Sélectionner les dates de l'événement",
  "Select the dates you want to join for this event": "Sélectionnez les dates auxquelles vous souhaitez participer à cet événement",
  "Join Selected Dates": "Rejoindre les dates sélectionnées",
  "Selected": "Sélectionné",
  "dates": "dates",
  "new": "nouveau",
  "Please select at least one new date": "Veuillez sélectionner au moins une nouvelle date",
  "No available dates for this event": "Aucune date disponible pour cet événement",
  "Accept This Event": "Accepter cet événement",
  "Accept All Events in Series": "Accepter tous les événements de la série",
  "Accept Event on Specific Dates": "Accepter l'événement à des dates spécifiques",
  "DIVIDER": "-------------------------------------------------------------DIVIDER---------------------------------------------------------------------",
  "formErrors": {
    "is required.": "est requis.",
    "is invalid.": "n'est pas valide.",
    "is required to be at least": "doit être d'au moins",
    "cannot be longer than": "ne peut pas être plus long que",
    "can't be greater than": "ne peut pas être supérieur à",
    "can't be less than": "ne peut pas être inférieur à",
    "must contain at least 1 in Capital Case!": "doit contenir au moins 1 en majuscule!",
    "must contain at least 1 Letter in Small Case!": "doit contenir au moins 1 lettre en minuscule!",
    "must contain at least 1 Special Character!": "doit contenir au moins 1 caractère spécial!",
    "do not match.": "ne correspondent pas.",
    "must be unique.": "doit être unique.",
    "must be greater than 0.": "doit être supérieur à 0.",
    "must be greater.": "doit être supérieur.",
    "must be greater than or equal.": "doit être supérieur ou égal.",
    "must be after the start date.": "doit être après la date de début.",
    "invalid pattern": "modèle invalide",
    "invalid pattern, 12345-1234 or 12345": "modèle invalide, 12345-1234 ou 12345"
  },
  "loginForm": {
    "Login into your account": "Connectez-vous à votre compte",
    "Username": "Nom d'utilisateur",
    "Password": "Mot de passe",
    "Remember me": "Se souvenir de moi",
    "I forgot my password": "J'ai oublié mon mot de passe",
    "Don't have an account?": "Vous n'avez pas de compte ?",
    "Login": "Connexion",
    "Sign up for Verein.cloud": "Inscrivez-vous sur verein.cloud®",
    "Password (6+ characters)": "Mot de passe (6+ caractères)"
  },
  "buttonComponent": {
    "Login": "Connexion",
    "Success": "Succès",
    "Save": "Enregistrer",
    "Processing": "Traitement",
    "Error": "Erreur",
    "Cancel": "Annuler",
    "done": "Terminé",
    "Join Event": "Rejoindre l'événement",
    "Leave Event": "Quitter l'événement"
  },
  "header": {
    "open": "Ouvrir",
    "close": "Fermer",
    "start typing": "Commencez à taper..",
    "messages": "Messages"
  },
  "nav": {
    "event tasks": "Tâches de l'événement",
    "event members": "Membres de l'événement",
    "create event form": "Créer un formulaire d'événement",
    "dashboard": "Tableau de bord",
    "news": "Actualités",
    "clubWall": "Mur du club",
    "community": "Communauté",
    "organizer": "Organisateur",
    "courses": "Cours",
    "tasks": "Tâches",
    "events": "Événements",
    "messages": "Messages",
    "settings": "Paramètres",
    "appointments": "Rendez-vous",
    "messages&groups": "Messages & Groupes",
    "task&appointments": "Tâches & Rendez-vous",
    "groups": "Groupes",
    "academic": "Académique",
    "app store": "App Store",
    "my profile": "Mon profil",
    "profile": "Profil",
    "club tools": "Outils du club",
    "marketing": "Marketing",
    "marketing tools": "Outils de Marketing",
    "banners": "Bannières",
    "create banner": "Créer une bannière",
    "create event": "Créer un événement",
    "emails": "Emails",
    "create email": "Créer un email",
    "tags": "Étiquettes",
    "survey": "Enquêtes",
    "course management": "Gestion des cours",
    "club FAQs": "FAQ du club",
    "group details": "Détails du groupe",
    "chat": "Chat",
    "events & club dates": "Événements et Dates du Club",
    "club addons": "Extensions du Club",
    "more": "Plus",
    "documents": "Documents",
    "add": "Ajouter",
    "faq": "FAQ",
    "my content": "Mon Contenu"
  },
  "dashboard": {
    "news posts": "Articles d'actualités",
    "message chats": "Discussions de messages",
    "tasks events": "Événements des tâches",
    "tasks": "Tâches",
    "news from the club": "Nouvelles du club",
    "current club dates": "Dates actuelles du club",
    "participant": "Participant",
    "read more": "Lire la suite",
    "clock": "Horloge",
    "popular": "Populaire",
    "latest": "Dernier",
    "Available Tasks": "Tâches disponibles",
    "posts": "Articles",
    "message": "Message",
    "chats": "Discussions",
    "available": "Disponible"
  },
  "community": {
    "group overview": "Vue d'ensemble du groupe",
    "dashboard": "Tableau de bord",
    "community": "Communauté",
    "messages": "Messages",
    "groups": "Groupes",
    "members": "Membres",
    "open chat": "Ouvrir le chat",
    "leave": "Quitter",
    "edit": "Modifier",
    "delete": "Supprimer",
    "add": "Ajouter",
    "create": "Créer",
    "show all groups": "Afficher tous les groupes",
    "groups you manage": "Groupes que vous gérez",
    "groups you are a member of": "Groupes dont vous êtes membre"
  },
  "groups": {
    "groups": "Groupes",
    "group": "Groupe",
    "group details": "Détails du groupe",
    "members": "Membres",
    "news": "Actualités",
    "tasks": "Tâches",
    "events": "Événements",
    "about": "À propos",
    "About this group": "À propos de ce groupe",
    "set": "Set",
    "your team": "Votre équipe",
    "new": "Nouveau",
    "group admin": "Administrateur de groupe",
    "age": "Âge",
    "no group": "Aucun groupe",
    "no event": "Aucun événement",
    "no task": "Aucune tâche",
    "no news": "Aucune nouvelle",
    "no member": "Aucun membre",
    "join success message": "Vous avez rejoint le groupe avec succès.",
    "waiting admin approval": "En attente de l'approbation de l'administrateur",
    "leave success message": "Vous avez quitté le groupe avec succès.",
    "delete success message": "Groupe supprimé avec succès."
  },
  "banners": {
    "link": "Lien",
    "content": "Contenu",
    "description": "Description",
    "banner status": "Statut",
    "update courses": "Mettre à jour les cours",
    "banner invoice": "Facture",
    "banner category": "Catégorie",
    "add description": "Ajouter une description",
    "create banner": "Créer une bannière",
    "thumbnail": "Miniature",
    "add image": "Ajouter une image",
    "title": "Titre",
    "sponsor": "Sponsor",
    "open space": "Espace ouvert",
    "app sponsor": "Sponsor de l'application",
    "group details": "Détails du groupe",
    "all groups": "Tous les groupes",
    "all news": "Toutes les actualités",
    "not paid": "Non payé",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "banner categories": "Catégories de bannières",
    "banner images": "Images de bannière",
    "banner link": "Lien de la bannière",
    "banner title": "Titre de la bannière",
    "edit banner": "Modifier la bannière",
    "banner display": "Affichage",
    "news details": "Détails des actualités",
    "banner placement": "Emplacement",
    "banner display tag": "Tag d'affichage de la bannière",
    "banner redirect link": "Lien de redirection"
  },
  "dates&filters": {
    "date": "Date",
    "days": "Jours",
    "day": "Jour",
    "hour": "Heure",
    "hours": "Heures",
    "time": "Heure",
    "year": "Année",
    "years": "Années",
    "month": "Mois",
    "months": "Mois",
    "week": "Semaine",
    "weeks": "Semaines",
    "opinion": "Avis",
    "event type": "Type d'événement",
    "sort and filter": "Trier et filtrer",
    "clear filters": "Effacer les filtres",
    "clear": "Effacer",
    "expired": "Expiré"
  },
  "messages": {
    "new group": "Nouveau groupe",
    "new chat": "Nouveau chat",
    "chat": "Chat",
    "personal": "Personnel",
    "club": "Club",
    "group": "Groupe",
    "clubs": "Clubs",
    "members": "Membre",
    "write a message": "Écrire un message",
    "media links and docs": "Médias, liens et documents",
    "group in common": "Groupe en commun",
    "close": "Fermer",
    "group name": "Nom du groupe",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "report": "Signaler"
  },
  "tags": {
    "tag": "Tag",
    "tags": "Tags",
    "tag name": "Nom du tag",
    "create tag": "Créer un tag",
    "instructor tag name": "Nom du tag de l'instructeur",
    "room tag name": "Nom du tag de la salle",
    "instructor": "Instructeur",
    "room": "Salle",
    "new tag": "Nouveau tag"
  },
  "users": {
    "my profile": "Mon Profil",
    "user profile": "Profil de l'Utilisateur",
    "user": "Utilisateur",
    "general information": "Informations Générales",
    "my payment data": "Mes Données de Paiement",
    "association master data": "Données Maîtresses de l'Association",
    "me at the club": "Moi au Club",
    "I in the company": "Moi dans l'Entreprise",
    "my address information": "Mes Informations d'Adresse",
    "communication data": "Données de Communication",
    "street number": "Numéro de Rue",
    "more info": "Plus d'Infos",
    "city": "Ville",
    "zip code": "Code Postal",
    "e-mail address": "Adresse E-mail",
    "phone number": "Numéro de Téléphone",
    "date of birth": "Date de Naissance",
    "address supplement": "Complément d'Adresse",
    "save profile": "Enregistrer le Profil",
    "password information": "Informations sur le Mot de Passe",
    "old password": "Ancien Mot de Passe",
    "minimum 6 characters": "Minimum 6 caractères",
    "change": "Changer",
    "bank holder name": "nom du titulaire de la banque",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Liens Sociaux",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Page d'accueil",
    "country": "Pays",
    "bank name": "Nom de la Banque",
    "member ship start date": "Date de Début de l'Adhésion",
    "My role in verein.cloud®": "Mon rôle dans verein.cloud®"
  },
  "club_tools": {
    "create question": "Créer une question",
    "faq categories": "Catégories FAQ",
    "start searching": "Commencer la recherche",
    "membership": "Adhésion",
    "maintenance and care": "Entretien et soin",
    "create faq": "Créer une FAQ",
    "update faq": "Mettre à jour la FAQ",
    "create title": "Créer un titre",
    "add description here": "Ajouter une description ici"
  },
  "courses": {
    "instructors": "Instructores",
    "rooms": "Salles",
    "all instructors": "Tous les Instructeurs",
    "all rooms": "Toutes les Salles",
    "today": "Aujourd'hui",
    "upcoming": "À venir",
    "join": "Rejoindre",
    "joined": "Rejoint",
    "rejected": "Rejeté",
    "persons": "Personnes",
    "search by room name": "Rechercher par nom de chambre",
    "join course": "Rejoindre le cours",
    "sorting": "Tri",
    "participants": "Participants",
    "about course": "À propos du cours",
    "course details": "Détails du cours",
    "helpText": "<p><strong>Managing Courses:</strong> Create courses by selecting available instructors and rooms that fit your schedule. Set visibility to 'Club Level' for everyone or 'Private' for specific groups/individuals, and assign tasks to stay organized.</p><p><strong>Discovering & Joining:</strong> Browse available courses in Card or Calendar views for your preferred dates and join with a single click.</p>"
  },
  "appointmentAndClub": {
    "start time": "Heure de début",
    "end time": "Heure de fin",
    "visibility": "Visibilité",
    "event name": "Nom de l'événement",
    "event location": "Lieu de l'événement",
    "room number (optional)": "Numéro de salle (optionnel)",
    "event price": "Prix de l'événement",
    "additional features": "Fonctionnalités supplémentaires",
    "show guests": "Afficher les invités",
    "chargeable": "Payant",
    "create event": "Créer un événement",
    "edit event": "Modifier un événement",
    "canceled": "Annulé",
    "pending": "En attente",
    "confirmed": "Confirmé",
    "location": "Emplacement",
    "responsible": "Responsable",
    "join event": "Rejoindre l'événement",
    "current": "Actuel",
    "tile view": "Vue en tuiles",
    "list view": "Vue en liste",
    "board": "Tableau",
    "view": "Vue",
    "my contributions": "Mes contributions",
    "Birthdays and anniversaries in the club": "Anniversaires et anniversaires dans le club",
    "Current events in the club": "Événements actuels dans le club",
    "Current events in the company": "Événements actuels dans l'entreprise"
  },
  "my content": {
    "title image": "Image de titre",
    "type": "Type",
    "actions": "Actions",
    "faqs": "FAQ"
  },
  "userprofile": {
    "personal information": "Informations personnelles",
    "create profile": "Créer un profil",
    "edit my profile": "Modifier mon profil",
    "digital membership card": "Carte de membre numérique",
    "payment information": "Informations de paiement",
    "digital card": "Carte numérique",
    "card holder name": "Carte titulaire nom",
    "card number": "Numéro de carte",
    "card type": "Type de carte",
    "expiration date": "Date d'expiration",
    "membership information": "Informations d'adhésion",
    "membership type": "Type d'adhésion",
    "membership number": "Numéro d'adhésion",
    "In the team since": "Dans l'équipe depuis",
    "approval / activation": "Approbation / Activation",
    "fair-share function": "Fonction de part équitable"
  },
  "RRULE": {
    "approximate": "approximatif",
    "and": "et",
    "at": "à",
    "day": "jour",
    "days": "jours",
    "every": "Chaque",
    "for": "pendant",
    "hour": "heure",
    "hours": "heures",
    "in": "dans",
    "last": "dernier(s)",
    "minutes": "minutes",
    "month": "mois",
    "months": "mois",
    "nd": "nd",
    "on the": "le",
    "on": "le",
    "or": "ou",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "le",
    "time": "fois",
    "times": "fois",
    "until": "jusqu'à",
    "week": "semaine",
    "weekday": "jour de semaine",
    "weekdays": "jours de semaine",
    "weeks": "semaines",
    "year": "année",
    "years": "années",
    "monthly": "mensuel",
    "yearly": "annuellement",
    "weekly": "hebdomadaire",
    "daily": "quotidiennement",
    "hourly": "horaire",
    "minutely": "chaque minute",
    "secondly": "chaque seconde",
    "starting from": "à partir de",
    "MO": "lundi",
    "TU": "mardi",
    "WE": "mercredi",
    "TH": "jeudi",
    "FR": "vendredi",
    "SA": "samedi",
    "SU": "dimanche",
    "RRule error: Unable to fully convert this rrule to text": "Erreur RRule : Impossible de convertir complètement cette RRule en texte"
  },
  "Add New": "Ajouter nouveau",
  "Create Group News": "Créer une actualité de groupe",
  "Create Group Task": "Créer une tâche de groupe",
  "Create Group Event": "Créer un événement de groupe"
}
